import { Country, CountryGeometry, UpsertCountry, UpsertCountryGeometry } from '@/models/country.model';
import { postReq } from '../infra/http';
import { getReq, createUrl } from "@/infra/http";
import { PaginationFilterRequest, PagedResponseModel, BaseResponseModel, PaginatedSelectModel } from "@/models/core.model";

export const getPagedCountries = async (input: PaginationFilterRequest): Promise<PagedResponseModel<Country>> => {
  return await getReq(createUrl("a/Country/PagedData"),
    { params: input }
  ).then((res: any) => res.data);
};

export const getCountriesLookup = async (input?: string, page?: number): Promise<PaginatedSelectModel> => {
  const model: PaginationFilterRequest = {
    pageNumber: page ?? 1,
    pageSize: 100,
    keyword: input,
    isAscending: false
  };
  return await getPagedCountries(model).then(data => 
    ({ 
      data: data.result.map(itm => ({ 
        value: itm.id, 
        label: itm.name
      })),
      isLastPage: data.pageNumber >= data.totalPages,
    })      
  );
};

export const getCountry = async (id: number): Promise<BaseResponseModel<Country>> => {
  return await getReq(createUrl(`a/Country/GetById/${id}`),
  ).then((res: any) => res.data);
};

export const upsertCountry = async (input: UpsertCountry): Promise<BaseResponseModel<Country>> => {
  return await postReq(createUrl("a/Country/Upsert"),
    input
  ).then((res: any) => res.data);
};

export const upsertCountryGeometry = async (input: UpsertCountryGeometry): Promise<BaseResponseModel<CountryGeometry>> => {
  return await postReq(createUrl("a/Country/Geometry/Upsert"),
    input
  ).then((res: any) => res.data);
};